import { PipelineStory } from '@aclass/admin/storage/actions';
import { INITIAL_PIPELINE_STATE, IPipelineModuleState } from '@aclass/admin/storage/states';
import { Action } from '@aclass/core/storage/action';
import { TypedState } from '@aclass/core/storage/states/module.state';
import { fromJS, List, Map } from 'immutable';

export const pipelineModuleReducer = (state: TypedState<IPipelineModuleState> = INITIAL_PIPELINE_STATE, action: Action) => {
    const { type, payload } = action;
    switch (type) {
        case PipelineStory.SEARCH_PAGE_UPDATE_INIT_STATE:
            return state.update('searchPageInitialized', () => payload);
        case PipelineStory.SEARCH_PAGE_UPDATE_COLLAPSED:
            return state.update('searchPageCollapsed', () => payload);
        case PipelineStory.SEARCH_PAGE_UPDATE_FORM:
            return state.update('searchPageForm', () => fromJS(payload));
        case PipelineStory.SEARCH_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('searchPageLock', () => payload);
        case PipelineStory.SEARCH_PAGE_UPDATE_PAGINATION:
            return state.update('searchPagePagination', () => Map(payload));
        case PipelineStory.SEARCH_PAGE_UPDATE_ORDER:
            return state.update('searchPageOrder', () => Map(payload));
        case PipelineStory.SEARCH_PAGE_IMPORT_RECORDS:
            return state.update('searchPageResults', () => List(payload));
        case PipelineStory.EDIT_PAGE_UPDATE_PIPELINE_ID:
            return state.update('editPageRecordId', () => payload);
        case PipelineStory.EDIT_PAGE_UPDATE_SAVE_LOCK:
            return state.update('editPageSaveLock', () => payload);
        case PipelineStory.EDIT_PAGE_UPDATE_FORM:
            return state.update('editPageForm', () => fromJS(payload));
        case PipelineStory.SEARCH_PAGE_DEFINITIONS_UPDATE_OPENED:
            return state.update('searchPageDefinitionsOpened', () => payload);
        default:
            return state;
    }
};
